import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * HomeRedirect sends the user to the appropriate landing page based on auth
 * state and role.
 *
 * While auth is loading, it renders nothing. Once resolved, an unauthenticated
 * user goes to the login screen; an accounting user lands on the WSIB workflow
 * view; everyone else lands on the fleet dashboard.
 *
 * @returns {JSX.Element | null}
 */
export default function HomeRedirect() {
  const { loadingUser, isAuthenticated, role } = useAuth();
  if (loadingUser) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (role === 'accounting') return <Navigate to="/accounting" replace />;
  return <Navigate to="/fleet-dashboard" replace />;
}
